import { CustomErrorCode } from '@dn/libs/ui/dn-common';

export const MaintenanceErrorCode = CustomErrorCode.CUSTOM_ERROR;
export const MaintenanceHttpErrorCode = 405;
export const DEFAULT_MAINTENANCE_MESSAGE = 'We are under maintenance at the moment, try again in a few minutes.';
